import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	fetchInAppNotifications,
	markInAppNotificationRead,
} from '../../store/notification/notificationActions';
import { COURSES_URL } from '../../components/app/routes';

function labelForType(type) {
	switch (type) {
		case 'tutor_student_purchased':
			return 'A student purchased courses';
		case 'tutor_student_rescheduled':
			return 'A student rescheduled a lesson';
		case 'tutor_student_canceled':
			return 'A student canceled a lesson';
		case 'student_tutor_rescheduled':
			return 'Your tutor rescheduled a lesson';
		case 'student_tutor_canceled':
			return 'Your tutor canceled a lesson';
		default:
			return type || 'Notification';
	}
}

function linkForNotification(n) {
	const p = n.payload || {};
	if (p.orderId) {
		if (n.type === 'tutor_student_purchased') return `/order/detail/${p.orderId}`;
		return `/order/payment/${p.orderId}`;
	}
	return COURSES_URL;
}

export function NotificationsPage() {
	const dispatch = useDispatch();
	const { inAppItems, inAppLoading, inAppTotal } = useSelector((s) => s.notification);

	useEffect(() => {
		dispatch(fetchInAppNotifications({ limit: 50 }));
	}, [dispatch]);

	return (
		<div className="max-w-3xl mx-auto px-4 py-8">
			<p className="text-slate-600 mb-6">
				{inAppTotal ? `${inAppTotal} total` : ' '}
			</p>
			{inAppLoading && <p className="text-slate-500">Loading…</p>}
			<ul className="space-y-3">
				{inAppItems.map((n) => (
					<li
						key={n.id}
						className={`rounded-xl border p-4 ${
							n.readAt ? 'border-slate-200 bg-white' : 'border-nt-blue/30 bg-slate-50'
						}`}
					>
						<div className="flex justify-between gap-3 items-start">
							<div>
								<p className="font-medium text-slate-900">{labelForType(n.type)}</p>
								<p className="text-sm text-slate-500 mt-1">
									{n.createdAt ? new Date(n.createdAt).toLocaleString() : ''}
								</p>
							</div>
							<div className="flex flex-col items-end gap-2 shrink-0">
								<Link
									to={linkForNotification(n)}
									className="text-sm text-nt-blue hover:underline"
									onClick={() => {
										if (!n.readAt) dispatch(markInAppNotificationRead(n.id));
									}}
								>
									Open
								</Link>
								{!n.readAt && (
									<button
										type="button"
										className="text-xs text-slate-600 hover:text-slate-900"
										onClick={() => dispatch(markInAppNotificationRead(n.id))}
									>
										Mark read
									</button>
								)}
							</div>
						</div>
					</li>
				))}
			</ul>
			{!inAppLoading && inAppItems.length === 0 && (
				<p className="text-slate-500 mt-4">No notifications yet.</p>
			)}
		</div>
	);
}
